import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fb30c54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "repair-type-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "报修类型", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "content-item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tag tag1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "支持质保/意外险极加/升级保养等全部服务权益，实际维慘权益以定责结果为准！", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "content-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tag tag2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createTextVNode("快捷提单选项，仅支持"),
  /*#__PURE__*/_createElementVNode("span", { class: "import-tip" }, "付费维修或升级保养"),
  /*#__PURE__*/_createTextVNode("等业务。 ")
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

import { ref } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'repair-type-detial-block',
  props: {
    isPay: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { isPay:  number };









return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (props.isPay === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
    ])
  ]))
}
}

})